import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import paymentMethodService from '../../service/paymentMethod.service';
import { FromTypeList, InstantPaymentTypeList, PaymentDeadlineBasisTypeList } from '../../config/paymentMethod';

export const PaymentMethodReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    paymentMethodService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Fizetési mód',
      type: 'string',
    },
    {
      field: 'paymentDeadlineBasis',
      headerName: 'Fizetési határidő alapja',
      type: 'singleSelect',
      valueOptions: PaymentDeadlineBasisTypeList,
    },
    {
      field: 'from',
      headerName: 'TÓL',
      type: 'singleSelect',
      valueOptions: FromTypeList,
    },
    {
      field: 'day',
      headerName: 'Nap',
      type: 'string',
    },
    {
      field: 'instantPayment',
      headerName: 'Azonnali fizetés',
      type: 'singleSelect',
      valueOptions: InstantPaymentTypeList,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.paymentMethod}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};
